module.exports = __webpack_public_path__ + "img/電気回路_2_4_5.76653ea9.png";